import React from 'react';
import { Link } from 'react-router-dom';
import salientLogo from '../../assets/images/logos/salient_logo.png';
import salientIso from '../../assets/images/logos/salient-isotipo-blanco.png';
import { useLanguage } from '../../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-salient-navy text-white border-t-4 border-salient-green relative overflow-hidden">
      {/* Marca de agua: isotipo salamandra */}
      <img
        src={salientIso}
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute right-0 bottom-0 h-[135%] w-auto opacity-[0.05] hidden md:block"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-2">
            {/* <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-salient-secondary to-white bg-clip-text text-transparent">
              Salient
            </h3> */}
            <img src={salientLogo} alt="Salient Logo" className="h-16 mb-4"/>
            <p className="text-gray-300">
              {t('footer.tagline')}
            </p>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-4">{t('footer.techTitle')}</h4>
            <ul className="space-y-2">
              <li><Link to="/tecnologia/redes" className="text-gray-300 hover:text-salient-green">{t('footer.redes')}</Link></li>
              <li><Link to="/tecnologia/cctv" className="text-gray-300 hover:text-salient-green">{t('footer.cctv')}</Link></li>
              <li><Link to="/tecnologia/software" className="text-gray-300 hover:text-salient-green">{t('footer.software')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-4">{t('footer.servicesTitle')}</h4>
            <ul className="space-y-2">
              <li><Link to="/marketing" className="text-gray-300 hover:text-salient-green">{t('footer.marketing')}</Link></li>
              <li><Link to="/otros-servicios" className="text-gray-300 hover:text-salient-green">{t('footer.energias')}</Link></li>
              <li><Link to="/equipos" className="text-gray-300 hover:text-salient-green">{t('footer.equipos')}</Link></li>
              {/* <li><Link to="/otros-servicios#alta-tension" className="text-gray-300 hover:text-salient-green">Proyectos de alta tensión</Link></li> */}
              <li className="pt-2">
                <a href="/portafolio-salient.pdf" download="Portafolio-Salient.pdf" className="inline-flex items-center gap-2 text-salient-green hover:text-salient-green font-medium">
                  <i className="fas fa-file-pdf"></i> {t('footer.downloadPortfolio')}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-4">{t('footer.contactTitle')}</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <i className="fa fa-envelope text-xl hover:text-blue-500"></i>                
                <a href="mailto:ventas@salient.mx" className="text-gray-300 hover:text-salient-green"><span>ventas@salient.mx</span></a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="fab fa-whatsapp text-xl"></i>
                <a href="https://wa.me/524423424429?text=Hola,%20me%20gustaría%20recibir%20información%20sobre%20sus%20servicios." target="_blank" rel="noreferrer" className="text-gray-300 hover:text-salient-green"><span>+52 442 342 4429</span></a>
              </li>
              {/* <li className="flex items-center space-x-2">
                <i className="fa fa-map-marker text-xl hover:text-blue-500"></i>
                <span>Ciudad de México, México</span>
              </li> */}
              <li className="mt-4">
                <Link to="/about-us" className="text-gray-300 hover:text-salient-green">{t('footer.quienesSomos')}</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-salient-green">{t('footer.contactanos')}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/10 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Salient. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
